import { of } from 'rxjs'
import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { ReceiptsElasticSearchService } from 'src/services/data/receipts-elastic.service'
import { prepareFiltersPayload, prepareReceiptsPayload } from './receipt-view-filters.utils'
import { TOP_LEVEL_FILTERS } from 'src/components/receipts/receipts-list/receipts-list.filters'
import { loadReceiptViews, loadReceiptViewsFailure, loadReceiptViewsSuccess, loadReceiptFilters, loadReceiptFiltersSuccess, loadReceiptFiltersFailure } from './receipt-view.actions'


@Injectable()
export class ReceiptViewEffects {
  private actions$ = inject(Actions)
  private elastic = inject(ReceiptsElasticSearchService)
  private toaster = inject(ToasterService)


  loadReceiptViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadReceiptViews),
    map(action => ({
      action,
      payload: prepareReceiptsPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) =>
      this.elastic.search({ ...payload, calculate: action.calculate }).pipe(
        map(r => loadReceiptViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          receiptViews: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch receipts', loadReceiptViewsFailure
      )))))

  loadReceiptFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadReceiptFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadReceiptFiltersSuccess({ tableKey, result })),
      catchError(error => of(loadReceiptFiltersFailure({ error }))),
    ))))
}
